import { render, staticRenderFns } from "./RowWidth.vue?vue&type=template&id=350ea2ee&"
import script from "./RowWidth.vue?vue&type=script&lang=js&"
export * from "./RowWidth.vue?vue&type=script&lang=js&"
import style0 from "./RowWidth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports